export const ContractActions = {
  new: 'new',
  update: 'update',
}

export const ContractStatus = {
  errored: 'errored',
  ready: 'ready',
  conflicted: 'conflicts',
}
